module.exports = __webpack_public_path__ + "img/owl-logo-white.c736abcd.svg";